import {
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { useState } from "react";
import { cn } from "../../../utils/helper";

export function CommonTable({ data, columns, noExtraRow = false, maxHeight }) {
  const [sorting, setSorting] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  const [columnVisibility, setColumnVisibility] = useState({});
  const [rowSelection, setRowSelection] = useState({});

  const table = useReactTable({
    data,
    columns,
    onSortingChange: setSorting,
    onColumnFiltersChange: setColumnFilters,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    onColumnVisibilityChange: setColumnVisibility,
    onRowSelectionChange: setRowSelection,
    state: {
      sorting,
      columnFilters,
      columnVisibility,
      rowSelection,
    },
  });

  return (
    <div className="overflow-x-auto hide-scroll horizontal-card-scrollbar">
      <div className="inline-block min-w-full rounded-2xl border overflow-hidden dark:border-none">
        <div
          className={cn({ "overflow-y-auto": maxHeight })}
          style={
            maxHeight
              ? { maxHeight, minHeight: maxHeight, backgroundColor: "white" }
              : {}
          }
        >
          <table className="min-w-full divide-y dark:divide-none divide-[#EAEAEA] text-shoorah-lightBlack">
            <thead className="dark:bg-shoorah-darkBgTabColor bg-[#FBFBFB]">
              {table.getHeaderGroups().map((headerGroup) => (
                <tr
                  key={headerGroup.id}
                  className="text-left font-medium whitespace-nowrap bg-[#DFDFDF] dark:bg-white dark:bg-opacity-10 dark:text-white"
                >
                  {headerGroup.headers.map((header, index) => (
                    <th
                      key={header.id}
                      className={cn(
                        `py-[13px] px-3 text-[15px] leading-[18px] font-normal dark:text-white text-black sticky top-0 z-10`,
                        header?.column?.columnDef?.meta?.className,
                        {
                          "pr-10": index === headerGroup.headers.length - 1,
                          "pl-10": index === 0,
                        }
                      )}
                      style={{ backgroundColor: "#DFDFDF" }}
                    >
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody className="dark:divide-shoorah-darkBgColor divide-[#EAEAEA] dark:bg-shoorah-darkBgTabColor bg-white">
              {!noExtraRow && (
                <tr>
                  <td colSpan={columns.length} className="h-[36px]"></td>
                </tr>
              )}
              {table.getCoreRowModel().rows?.length ? (
                table.getCoreRowModel().rows.map((row, index) => (
                  <tr
                    key={row.id}
                    data-state={row.getIsSelected() && "selected"}
                    className="hover:bg-[#EEEEEE] md:cursor-pointer dark:hover:bg-shoorah-darkBgColor"
                  >
                    {row.getVisibleCells().map((cell, ind) => (
                      <td
                        key={cell.id}
                        className={cn(
                          `p-3 dark:text-white whitespace-nowrap`,
                          cell?.column?.columnDef?.meta?.rowClassName,
                          {
                            "pl-10": ind === 0,
                            "pr-10": ind === row.getVisibleCells().length - 1,
                          }
                        )}
                      >
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length} className="h-24 text-center">
                    No results.
                  </td>
                </tr>
              )}
              {!noExtraRow && (
                <tr>
                  <td colSpan={columns.length} className="h-[52px]"></td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
